import { render, staticRenderFns } from "./dial.vue?vue&type=template&id=45830afb&scoped=true"
import script from "./dial.vue?vue&type=script&lang=js"
export * from "./dial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45830afb",
  null
  
)

export default component.exports